<template>
  <div class="ws-logs">
    <div class="columns">
      <h3 class="is-size-2 column">Демонстрационный экзамен</h3>
    </div>
    <WsExamLog
      :examLogs="examLogs"
      :examPagination="examPagination"
      :files="files"
      :users="users"
      :isExamPending="isExamPending"
      @pageChange='onExamPageChange'
    />
    <div class="columns">
      <h3 class="is-size-2 column">Экзаменационные группы</h3>
    </div>
    <ws-list-view
      class="ws-logs__list exam-groups is-table is-small"
      itemFieldIdKey="id"
      :data="examGroupLogs"
      :columns="columnsExamGroup"
      :header="true"
      :bordered="true"
      :striped="true"
      :skeleton="isPending"
      :detailed="false"
    >
      <template slot="skeleton">
        <ws-list-view-skeleton-item
          :height="'39px'"
          :boxCount="1"
          :boxHeights="['38px']"
        />
        <ws-list-view-skeleton-item
          :height="'42px'"
          :boxCount="3"
          :boxHeights="['25px', '25px', '25px', '25px']"
        />
        <ws-list-view-skeleton-item
          :height="'42px'"
          :boxCount="3"
          :boxHeights="['25px', '25px', '25px', '25px']"
        />
        <ws-list-view-skeleton-item
          :height="'42px'"
          :boxCount="3"
          :boxHeights="['25px', '25px', '25px', '25px']"
        />
        <ws-list-view-skeleton-item
          :height="'42px'"
          :boxCount="3"
          :boxHeights="['25px', '25px', '25px', '25px']"
        />
      </template>
      <template slot-scope="props">
        <ws-list-view-item-column>
          <div class="is-fullwidth">
            <ws-time-formatter
              data-id="day-cm1-column"
              class="is-size-4"
              format="LLL"
              :date="props.row.action_time"
            />
          </div>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <div class="is-fullwidth">
            {{ getLogActionCategory(props.row.category).label }}
          </div>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <div class="is-fullwidth">
            {{ getLogField(props.row.field).label }}
          </div>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <div class="is-fullwidth log-cell">
            <template
              v-if="props.row.old_value &&
                isExperts(props.row.category, props.row.old_value) &&
                getAuthor(props.row.old_value)"
            >
              <span class="has-text-weight-bold">{{ getAuthor(props.row.old_value).last.display }} {{ getAuthor(props.row.old_value).first.display }}</span>
              <span> ({{  getAuthor(props.row.old_value).email }})</span>
            </template>
            <template v-else-if="isDateFormat(props.row.field)">
              <span>{{getDate(props.row.old_value)}}</span>
            </template>
            <template v-else>
              {{ getLogValue(props.row.old_value, props.row.field).label }}
            </template>
          </div>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <div class="is-fullwidth log-cell">
            <template
              v-if="props.row.new_value &&
                isExperts(props.row.category, props.row.new_value) &&
                getAuthor(props.row.new_value)"
            >
              <span class="has-text-weight-bold">{{ getAuthor(props.row.new_value).last.display }} {{ getAuthor(props.row.new_value).first.display }}</span>
              <span> ({{  getAuthor(props.row.new_value).email }})</span>
            </template>
            <template v-else-if="isDateFormat(props.row.field)">
              <span>{{getDate(props.row.new_value)}}</span>
            </template>
            <template v-else>
              {{ getLogValue(props.row.new_value, props.row.field).label }}
            </template>
          </div>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <div class="is-fullwidth log-action">
            <b-tag :type="`is-${getLogAction(props.row.action).type}`">
              {{ getLogAction(props.row.action).label }}
            </b-tag>
          </div>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <div class="is-fullwidth log-cell" v-if="getAuthor(props.row.author)">
            <span class="has-text-weight-bold">{{ getAuthor(props.row.author).last.display }} {{ getAuthor(props.row.author).first.display }}</span>
            <span> ({{  getAuthor(props.row.author).email }})</span>
          </div>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <div class="is-fullwidth log-cell" v-if="getAuthor(props.row.user_id)">
            <span class="has-text-weight-bold">{{ getAuthor(props.row.user_id).last.display }} {{ getAuthor(props.row.user_id).first.display }}</span>
            <span> ({{  getAuthor(props.row.user_id).email }})</span>
          </div>
        </ws-list-view-item-column>
      </template>
      <template
        slot="details"
        slot-scope="props"
      >
        <pre
          class="is-fullwidth"
          style="background-color: #262d3b; color: #c0cc93; border-radius: 5px;"
        >{{ props.row.additional_info }}</pre>
      </template>
      <template slot="empty">
        <p>{{ $t('Нет данных для отображения')}}</p>
      </template>
    </ws-list-view>
    <footer class="ws-logs__footer">
      <ws-pagination
        @change="onExamGroupPageChange"
        :align="'right'"
        :totalItems="examGroupPagination.total"
        :itemsPerPage="examGroupPagination.per_page"
        :disabled="isExamGroupPending"
        :currentIndex="examGroupPagination.current_page - 1"
      >
      </ws-pagination>
    </footer>
    <b-loading
      :is-full-page="false"
      :active="isExamPending || isExamGroupPending"
      :can-cancel="true"
    ></b-loading>
  </div>
</template>

<script>

import { mapActions, mapState, mapGetters } from 'vuex'
import listMixin from '@/mixins/list.mixin'
import {
  FILE_CATEGORY,
  LOGS_ACTION_CATEGORIES,
  LOG_VALUE_SETTINGS,
  LOG_FIELDS,
  getLogActionCategory,
  isValidGuid,
  isExperts,
  getLogAction,
  getLogField,
  isDateFormat,
  getDate
} from '@/components/de/demo-exams/data/log-data.js'
import WsExamLog from './WsExamLog.vue'

export default {
  name: 'WsExamLogsList',
  mixins: [listMixin],
  components: {
    WsExamLog
  },
  props: {
    guid: String
  },
  data () {
    return {
      per_page: 10,
      per_page2: 10,
      examLogs: [],
      examGroupLogs: [],
      examPagination: {},
      examGroupPagination: {},
      examGroups: [],
      isExamPending: false,
      isExamGroupFetch: false,
      isExamGroupPending: false,
      files: {},
      page2: 1,
      columnsExamGroup: [
        {
          field: 'created_at',
          label: 'Время'
          // width: '100px'
        },
        {
          field: 'category',
          label: 'Категория'
          // width: '100px'
        },
        {
          field: 'field',
          label: 'Поле'
        },
        {
          field: 'old_value',
          label: 'Старое значение'
        },
        {
          field: 'new_value',
          label: 'Новое значение'
        },
        {
          field: 'action',
          label: 'Действие'
        },
        {
          field: 'user_id',
          label: 'Автор'
        },
        {
          field: 'participant',
          label: 'Участник'
        }
      ],
      users: []
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters('exams', {
      getExamById: 'get'
    }),
    ...mapState('exams', {
      isGetPending: 'isGetPending'
    }),
    ...mapGetters('my-exams', {
      getMyExamById: 'get'
    }),
    ...mapState('my-exams', {
      isMyGetPending: 'isGetPending'
    }),
    ...mapState('authentication', {
      currentRole: 'currentRole'
    }),
    exam () {
      if (this.isMy) {
        // return this.getMyExamById(this.getExamGuid)
        return this.getExamById(this.getExamGuid)
      } else {
        return this.getExamById(this.getExamGuid)
      }
    },
    getExamGuid () {
      return this.$route.params.id
    },
    isPending () {
      return this.isFindPending && this.list.length === 0
    },
    isMy () {
      return this.currentRole === 'front_me' || this.currentRole === 'front_le' || this.currentRole === 'front_tech_expert'
    }
  },
  methods: {
    ...mapActions('esatk/users-list', { findUsers: 'find' }),
    ...mapActions('event-log', ['getExamLogs', 'getExamGroupLogs']),
    ...mapActions('exams', ['get', 'getExamGroups']),
    ...mapActions('my-exams', {
      getMy: 'get'
    }),
    ...mapActions('profile/files', {
      getFileByRecId: 'getFileByRecId'
    }),
    getLogActionCategory,
    isValidGuid,
    isExperts,
    getLogAction,
    getLogField,
    isDateFormat,
    getDate,
    onExamPageChange (pagination) {
      this.page = pagination.page + 1
      this.per_page = pagination.per_page
      this.fetchExamLogs()
    },
    onExamGroupPageChange (pagination) {
      this.page2 = pagination.page + 1
      this.per_page2 = pagination.per_page
      this.fetchExamGroupLogs()
    },
    getLogValue (value, field) {
      if (LOG_FIELDS.EXAM_GROUP === field && isValidGuid(value)) {
        const group = this.examGroups.find(i => i.guid === value)
        return group ? { label: group.number } : { label: value }
      }
      if (!LOG_VALUE_SETTINGS[value]) {
        if (this.isValidGuid(value) && FILE_CATEGORY[field]) {
          const file = this.files[FILE_CATEGORY[field]] &&
            this.files[FILE_CATEGORY[field]].find(i => i.guid === value)
          return { label: file ? file.file_name : value }
        }
        return { label: value }
      }
      return LOG_VALUE_SETTINGS[value]
    },
    getAuthor (guid) {
      return this.users.find(i => i.guid === guid)
    },
    async getFile (category) {
      const files = await this.getFileByRecId({
        'rec-guid': this.guid,
        'category': `de-${category}`,
        query: 'with_deleted=true'
      })
      this.files[category] = files
    },
    async _fetch () {
      this.isExamPending = true
      const promises = [
        await this.getExamLogs({
          params: { examGuid: this.guid },
          query: `page=${this.page}&per_page=${this.per_page}`
        }),
        this.getExamGroupLogs({
          params: { examGuid: this.guid },
          query: `page=${this.page2}&per_page=${this.per_page2}`
        })
      ]
      const res = await Promise.all(promises)
      this.examPagination = res[0].meta
      this.examGroupPagination = res[1].meta
      this.examLogs = Array.isArray(res[0].data) ? res[0].data : []
      this.examGroupLogs = Array.isArray(res[1].data) ? res[1].data : []
      await this.fetchUsers()
      this.isExamPending = false
    },
    async fetchUsers () {
      const authors = []
      const fileTypes = []
      let actions = []
      this.examLogs.forEach(user => {
        if (FILE_CATEGORY[user.field] &&
          !this.files[FILE_CATEGORY[user.field]] &&
          !fileTypes.includes(FILE_CATEGORY[user.field])
        ) {
          fileTypes.push(FILE_CATEGORY[user.field])
          actions.push(this.getFile(FILE_CATEGORY[user.field]))
        }
        if (!authors.includes(user.author)) {
          authors.push(user.author)
        }
        if (user.category === LOGS_ACTION_CATEGORIES.EXPERTS) {
          if (user.new_value && this.isValidGuid(user.new_value)) {
            if (!authors.includes(user.new_value)) {
              authors.push(user.new_value)
            }
          }
          if (user.old_value && this.isValidGuid(user.old_value)) {
            if (!authors.includes(user.old_value)) {
              authors.push(user.old_value)
            }
          }
          if (user.expert_id && this.isValidGuid(user.expert_id)) {
            if (!authors.includes(user.expert_id)) {
              authors.push(user.expert_id)
            }
          }
        }
      })
      this.examGroupLogs.forEach(user => {
        if (FILE_CATEGORY[user.field] &&
          !this.files[FILE_CATEGORY[user.field]] &&
          !fileTypes.includes(FILE_CATEGORY[user.field])
        ) {
          actions.push(this.getFile(FILE_CATEGORY[user.field]))
          fileTypes.push(FILE_CATEGORY[user.field])
        }
        if (LOG_FIELDS.EXAM_GROUP === user.field &&
          (isValidGuid(user.new_value) ||
          isValidGuid(user.old_value)) &&
          !this.isExamGroupFetch) {
          this.isExamGroupFetch = true
          actions.push(this.fetchExamGroups())
        }
        if (!authors.includes(user.author)) {
          authors.push(user.author)
        }
        if (!authors.includes(user.user_id)) {
          authors.push(user.user_id)
        }
        if (user.category === LOGS_ACTION_CATEGORIES.EXPERTS) {
          if (user.new_value && this.isValidGuid(user.new_value)) {
            if (!authors.includes(user.new_value)) {
              authors.push(user.new_value)
            }
          }
          if (user.old_value && this.isValidGuid(user.old_value)) {
            if (!authors.includes(user.old_value)) {
              authors.push(user.old_value)
            }
          }
        }
      })
      if (authors.length) actions = [this.findUsers({ guid: authors }), ...actions]
      if (actions.length) {
        const [users] = await Promise.all(actions)
        this.users = users || []
      }
    },
    fetchExamGroups () {
      this.getExamGroups({ examGuid: this.guid, query: `page=${1}&per_page=${50}&with_deleted=true` }).then(res => {
        this.examGroups = res || []
      })
    },
    async fetchExamLogs () {
      this.isExamPending = true
      const res = await this.getExamLogs({
        params: { examGuid: this.guid },
        query: `page=${this.page}&per_page=${this.per_page}`
      })
      this.examPagination = res.meta
      this.examLogs = res.data
      await this.fetchUsers()

      this.isExamPending = false
    },
    async fetchExamGroupLogs () {
      this.isExamGroupPending = true
      const res = await this.getExamGroupLogs({
        params: { examGuid: this.guid },
        query: `page=${this.page2}&per_page=${this.per_page2}`
      })
      this.examGroupLogs = res.data
      this.examGroupPagination = res.meta
      await this.fetchUsers()
      this.isExamGroupPending = false
    }
  },
  async mounted () {
    if (this.isMy) {
      // await this.getMy([this.getExamGuid])
      await this.get([this.getExamGuid])
    } else {
      await this.get([this.getExamGuid])
    }
    await this._fetch()
  }
}
</script>

<style lang="scss">
.ws-logs__exam {
  margin-bottom: 2rem;
}
.ws-logs__list {
  position: relative;
  min-height: 150px;
  margin-bottom: 1rem;

  &.is-table {
    .ws-list-view__header,
    .ws-list-view__content {
      display: grid;
      grid-template-columns: minmax(100px, 1fr) 100px minmax(100px, 1fr) minmax(190px, 1fr) minmax(190px, 1fr) 100px minmax(170px, 1fr);
      grid-column-gap: 1px;
    }
    .ws-list-view__item-column {
      padding: 5px 10px;
      word-wrap: break-word;
    }
  }

  &.exam-groups {
    .ws-list-view__header,
    .ws-list-view__content {
      grid-template-columns: minmax(100px, 1fr) 100px minmax(100px, 1fr) minmax(190px, 1fr) minmax(190px, 1fr) 100px minmax(170px, 1fr) minmax(170px, 1fr);
    }
  }
}
.ws-logs {
  position: relative;
  padding: 0 20px 20px 0;
}
.log-cell {
  span {
    word-break: break-all;

    &:first-child {
      display: block;
    }
  }
}
.log-action {
  text-align: center;
}
</style>
